<template>
  <div id="boothSelectLog">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'boothSelectLog'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/exhibition/log/booth/BoothSelectLog.vue